import { buttonVariants } from "@cleanbudget/ui/components/button";
import { cn } from "@cleanbudget/ui/lib/utils";
import { createLink, type LinkComponent } from "@tanstack/react-router";
import type { ComponentProps } from "react";

/**
 * A navigation that looks like a button ("Medewerker toevoegen"): a real link (`<a href>`, opens in
 * a new tab, preloads on hover) with the button's looks. Not `<Button render={<Link />}>`, which would
 * make it announce itself as a button.
 */
function StyledAnchor({
	className,
	variant,
	size,
	...props
}: ComponentProps<"a"> & Pick<NonNullable<Parameters<typeof buttonVariants>[0]>, "variant" | "size">) {
	return <a data-slot="button" className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}

const LinkAnchor = createLink(StyledAnchor);

export const ButtonLink: LinkComponent<typeof StyledAnchor> = (props) => (
	<LinkAnchor preload="intent" {...props} />
);
